module.exports = __webpack_public_path__ + "static/Deborah-b6b4c71db8f7f797b7d29e12ed4045a3.jpg";